import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Hosts } from '../../constants/hostName';
import { IPathnameInitialStateProps, pathnameInitialState } from './pathnameInitialState';

export const slice = createSlice({
  name: 'siteSettings',
  initialState: pathnameInitialState,
  reducers: {
    setSettings: (state:IPathnameInitialStateProps, action:PayloadAction<{ pathname: string }>): void => {
      if (action.payload.pathname?.includes('/nosh')) {
        state.host = 'nosh.com';
        state.color = '#54BA5D';
        state.siteNumber = Hosts.NOSH;
        state.pathname = '/nosh';
      } else if (action.payload.pathname?.includes('/brewbound')) {
        state.host = 'brewbound.com';
        state.color = '#14aac0';
        state.siteNumber = Hosts.BREWBOUND;
        state.pathname = '/brewbound';
      } else if (action.payload.pathname?.includes('/bevnet')) {
        // Explicit BevNET-sourced entry (e.g. /PostJobListing/bevnet). Same
        // BevNET attribution as the bare route, but a set `pathname` marks that
        // a source brand was named, so the cross-brand banner may show.
        state.host = 'bevnet.com';
        state.color = '#ce0e2d';
        state.siteNumber = Hosts.BEVNET;
        state.pathname = '/bevnet';
      } else {
        // Bare route with no source brand (e.g. /PostJobListing) — this is the native
        // CPG Jobs board, so attribute to CPG Jobs (siteId 8) which resolves to the
        // CPG Jobs_Products / Jobs_Prepaid_Products rows. `pathname` stays null so the
        // cross-brand "Looking for the … job board?" strip is suppressed (there's no
        // source brand to reassure about). host/color left as-is (styling untouched).
        state.host = 'bevnet.com';
        state.color = '#ce0e2d';
        state.siteNumber = Hosts.CPGJOBS;
        state.pathname = null;
      }
    }

  },
});

export const { setSettings } = slice.actions;
export default slice.reducer;
